export default [
  {
    path: '/auth',
    name: 'auth',
    children: [
      {
        path: 'signout',
        name: 'signout',
        component: () => import('@/views/auth/login/Login.vue')
      },
      {
        path: 'oidc-callback',
        name: 'oidc-callback',
        component: () => import('@/views/auth/login/openid/Callback.vue')
      }
    ]
  }
];
